module.exports = __webpack_public_path__ + "img/pic_default.84af175a.png";